import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { DeleteMediaHit, type DeleteMediaHitMutation, type DeleteMediaHitMutationVariables } from './index.graphql';

export async function deleteMediaHit(
	mediaId: string,
	utilityContext: UtilityContext,
): Promise<DeleteMediaHitMutation | null | undefined> {
	const {
		gql: { fetch },
	} = utilityContext;

	const { data } = await fetch<DeleteMediaHitMutation, DeleteMediaHitMutationVariables>({
		query: DeleteMediaHit,
		variables: {
			input: {
				commentId: mediaId,
			},
		},
		rejectOnError: false,
	});
	return data;
}
